import { createTemplate } from "@brains/templates";
import { linkDetailDataSchema, type LinkDetailData } from "./schema";
import { LinkDetailLayout } from "./layout";

export const linkDetailTemplate: ReturnType<
  typeof createTemplate<LinkDetailData>
> = createTemplate<LinkDetailData>({
  name: "link:link-detail",
  description: "Detail view of a captured link",
  schema: linkDetailDataSchema,
  dataSourceId: "link:entities",
  requiredPermission: "public",
  layout: {
    component: LinkDetailLayout,
  },
});

export { LinkDetailLayout } from "./layout";
export {
  linkDetailDataSchema,
  type LinkDetailData,
  type LinkDetail,
} from "./schema";
